import type { ReactNode } from 'react';

import { MobileGuard } from '../components/MobileGuard';
import { MobileTabBar } from '../components/MobileTabBar';

interface MobileShellProps {
  children: ReactNode;
}

/**
 * 모바일 레이아웃 (docs/design/dashfolio-dna.md §4).
 *
 * `.admin-root` scope 가 최상위에 적용되어 admin 토큰 활성화.
 * 상단 경량 헤더 + MobileGuard 가 페이지별 접근 차단 → 하단 탭바 5칸.
 */
export function MobileShell({ children }: MobileShellProps) {
  return (
    <div className="admin-root dark flex min-h-dvh flex-col bg-[var(--color-admin-window)] text-[var(--color-admin-text)]">
      <header className="sticky top-0 z-20 flex h-12 items-center justify-between border-b border-[var(--color-admin-hairline)] bg-[var(--color-admin-sidebar)] px-4">
        <span className="text-[13px] font-semibold tracking-tight">Lashpic Admin</span>
        <span className="text-[10px] font-semibold uppercase tracking-[0.12em] text-[var(--color-admin-text-tertiary)]">
          Mobile
        </span>
      </header>
      <main className="flex-1 overflow-y-auto px-4 py-4 pb-[80px]">
        <MobileGuard>{children}</MobileGuard>
      </main>
      <MobileTabBar />
    </div>
  );
}
